import { render, staticRenderFns } from "./uniquement-vos-dommages.vue?vue&type=template&id=01cdb4c8&scoped=true"
import script from "./uniquement-vos-dommages.vue?vue&type=script&lang=ts"
export * from "./uniquement-vos-dommages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cdb4c8",
  null
  
)

export default component.exports